import { Text } from "@storyofams/react-ui";
import { useTimer } from "react-timer-hook";

export const Timer = ({ endDate }) => {
  const expiryTimestamp = new Date();
  const newDate = new Date(endDate);
  expiryTimestamp.setSeconds(
    (newDate.getTime() - expiryTimestamp.getTime()) / 1000
  );
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp,
    autoStart: true,
  });
  return (
    <Text fontWeight={[500, 600]} fontSize={["16px", "18px"]}>
      {(String(hours + days * 24).length === 1
        ? "0" + (hours + days * 24)
        : hours + days * 24) + "h"}
      <Text mx={"3px"} display={"inline"}>
        :
      </Text>
      {(String(minutes).length === 1 ? "0" + minutes : minutes) + "m"}
      <Text mx={"3px"} display={"inline"}>
        :
      </Text>
      {(String(seconds).length === 1 ? "0" + seconds : seconds) + "s"}
    </Text>
  );
};
